import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { AppComponent } from "./app.component";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-topbar",
    templateUrl: "./app.topbar.component.html",
})
export class AppTopBarComponent implements OnInit {
    UserDetails: any ={userName:''};
    mscvpRole = "";
    display: boolean;
    enableWebForms :boolean = false;
    webFormsUrl:any;
    
    constructor(
        public app: AppComponent,
        private session: SessionStorageService,
        private router: Router,
        public localstorage: LocalStorageService,
    ) {}
    ngOnInit() {
        this.UserDetails = this.session.retrieve("UserDetails");
        // console.log(this.UserDetails);
        if(this.UserDetails !== null){
        if(this.UserDetails.webForms == "true"){
            this.enableWebForms = true;
            // this.webFormsUrl = environment.webFormsUrl
            const token1 = this.localstorage.retrieve("token");
            const password = this.session.retrieve('password')
            this.webFormsUrl =   environment.webFormsUrl + `/webForms/dashboard?token=${btoa(token1)}&loginId=${btoa(this.UserDetails.loginId)}&password=${btoa(password)}`
        }
        else{
            this.enableWebForms = false;
        }
    }
    }
    logout() {
        this.localstorage.store("token","")
        sessionStorage.clear();
        this.session.clear();
        this.router.navigateByUrl("login");
    }
    changepwd() {
        this.display = true;
    }
}
